import {
  invalidateTimesheetQueries,
  timesheetKeys,
} from "components/timesheet/queries";

import { TIMESHEET_QUERY_KEYS } from "components/timesheet/query-keys";
import { deleteTimesheetEntry } from "components/timesheet/delete/api";
import { queryClient } from "utils/react-query";
import { toast } from "sonner";
// hooks/useDeleteTimesheetEntry.js
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

export function useDeleteTimesheetEntry({ entryId, date, onSuccess }) {
  return useMutation({
    mutationFn: () => deleteTimesheetEntry({ id: entryId }),
    onMutate: async () => {
      // Define query keys
      const timesheetQueryKey = timesheetKeys.log(date);

      // Cancel outgoing refetches
      await queryClient.cancelQueries({ queryKey: timesheetQueryKey });

      // Snapshot previous values for rollback
      const previousTimesheet = queryClient.getQueryData(timesheetQueryKey);

      // Check if data exists

      // Optimistically update timesheet data
      queryClient.setQueryData(timesheetQueryKey, (old) => {
        if (!old || !Array.isArray(old)) {
          console.warn("⚠️ Timesheet data is not an array:", old);
          return old;
        }
        return old.filter((entry) => entry.id !== entryId);
      });

      // Return context for rollback
      return { previousTimesheet };
    },
    onError: (error, context) => {
      console.error("❌ Delete mutation failed:", error);

      // Rollback optimistic updates if we have context
      if (context?.previousTimesheet) {
        queryClient.setQueryData(
          timesheetKeys.log(date),
          context.previousTimesheet,
        );
      }

      console.error(error);

      toast.error("Failed to delete the entry");
    },
    onSuccess: () => {
      toast.success("Entry Deleted Successfully");
      invalidateAllQueries();
      onSuccess?.();
    },
    onSettled: () => {
      // Always invalidate queries to ensure consistency
      queryClient.invalidateQueries({
        queryKey: timesheetKeys.log(date),
        exact: true,
      });
    },
  });
}
